import {mainQuery} from '@github-ui/react-core/future/main-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {FindingsRoutePayload} from './route-payload-types'
import {FindingsRoutePath} from './route-paths'

export const pullRequestsFindingsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsFindingsRoute', {
  path: FindingsRoutePath,
  queries: [mainQuery<FindingsRoutePayload>()],
})
